import { rankWith } from '@jsonforms/core';
import { hasCustomComponent } from '../utils/testers';
import { withJsonFormsControlProps } from '../utils/withJsonFormsPropsMappers';

export const Hidden = () => {
  return null;
};

export default withJsonFormsControlProps(Hidden);

export const hiddenTester = rankWith(6, hasCustomComponent('hidden'));
